<template>
  <div class="body-container">
    <TopNavbar title="书评"></TopNavbar>
    <div v-if="itemId" class="item-box-container">
      <ItemBox :itemId="itemId" :showItemRate="true"></ItemBox>
    </div>
    <CommentInfo :itemId="itemId" v-if="itemId"></CommentInfo>
  </div>
</template>
<script>
  import CommentInfo from "./CommentInfo";
  import {Toast, Loading} from "vant"
  import LoadingComponent from "../common/LoadingComponent";
  import TopNavbar from "../common/TopNavbar";
  import ItemBox from "../ugc_item/ItemBox";

  export default {
    components: {ItemBox, TopNavbar, LoadingComponent, CommentInfo, Loading},
    name: "CommentPage",
    data() {
      return {
        itemId: 0,
        item: {},
        showLoading: true,
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.itemId = parseInt(this.$route.params.id)
      }
      this.getItem()
    },
    methods: {
      async getItem() {
        this.showLoading = true
        let params = {
          id: this.itemId
        }
        await this.$store.dispatch("GetUgcItem", params).then((data) => {
              if (data.code !== 0) {
                Toast("内容不存在")
              } else {
                this.item = data.data;
              }
              console.log(this.item)
            }, () => {
              Toast.fail("网络错误")
            }
        );
        this.showLoading = false
      },
      showNovelItem(item) {
        this.$router.push('/novel/' + item.id);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .body-container {
    padding-top: 55px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
</style>

